<template>
    <div class="report-add">
        <div class="card">
            <div class="card-hd">
                <img src="https://staticwecom.beautyfarm.com.cn/20251230/icon1.png" alt="">
                <div>门店信息</div>
            </div>
            <div class="report-item">
                <div class="item-label">门店编码</div>
                <div class="item-value">{{ info.storeNo }}</div>
            </div>
            <div class="report-item">
                <div class="item-label">门店名称</div>
                <div class="item-value">{{ info.storeName }}</div>
            </div>
        </div>

        <div class="card">
            <div class="card-hd">
                <img src="https://staticwecom.beautyfarm.com.cn/20251230/icon2.png" alt="">
                <div>报备信息</div>
            </div>
            <div class="report-item">
                <div class="item-label">
                    <span>报备类型</span>
                    <span class="red">*</span>
                </div>
                <div class="item-value" @click="showReportTypePicker = true">
                    <span v-if="info.reportTypeStr">{{ info.reportTypeStr }}</span>
                    <span v-else class="gery">请选择报备类型</span>
                    <van-icon name="arrow" color="#A0ACB5" />
                </div>
            </div>

            <div class="report-item">
                <div class="item-label">
                    <span>开始时间</span>
                    <span class="red">*</span>
                </div>
                <div class="item-value" @click="onShowStartDatePicker">
                    <span v-if="info.startDate">{{ info.startDate }}</span>
                    <span v-else class="gery">年/月/日</span>
                    <img src="https://staticwecom.beautyfarm.com.cn/20251230/calendar.png" alt="">
                </div>
            </div>
            <div class="report-item">
                <div class="item-label">
                    <span>结束时间</span>
                    <span class="red">*</span>
                </div>
                <div class="item-value" @click="onShowEndDatePicker">
                    <span v-if="info.endDate">{{ info.endDate }}</span>
                    <span v-else class="gery">年/月/日</span>
                    <img src="https://staticwecom.beautyfarm.com.cn/20251230/calendar.png" alt="">
                </div>
            </div>
            <div class="report-item">
                <div class="item-label">
                    <span>报备说明</span>
                    <span class="red">*</span>
                </div>
                <div class="item-textarea">
                    <van-field v-model="info.reportDes" rows="3" autosize type="textarea" maxlength="500" placeholder="请详细描述报备原因和相关情况" />
                    <span class="textarea-tips">20-500字</span>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-hd">
                <img src="https://staticwecom.beautyfarm.com.cn/20251230/icon3.png" alt="">
                <div>证明材料</div>
            </div>

            <div class="file-list" v-for="(it, i) in info.fileUrls" :key="i">
                <img v-if="isImageFile(it)" class="file-img" :src="it" @click="imagePreview(it)">
                <van-icon v-else size="48" name="orders-o" />
                <div class="file-info">
                    <div class="file-name">{{ getFileName(it) }}</div>
                    <div class="file-detail">
                        <div></div>
                        <div class="file-reUpload">
                            <van-uploader accept="file" :max-count="maxCount" :max-size="maxSize" @oversize="onOversize(item.select_max_size)" :after-read="(file) => { afterRead(file, i) }">
                                <span class="text">重新选择</span>
                            </van-uploader>
                            <van-icon name="delete-o" size="22px" color="#ff4545" @click="onDelFile(i)" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="upload-card" v-if="info.fileUrls.length < 9">
                <van-uploader accept="file" :max-count="maxCount" :max-size="maxSize" @oversize="onOversize(item.select_max_size)" :after-read="(file) => { afterRead(file) }">
                    <div class="upload-box">
                        <img class="upload-img" src="https://staticwecom.beautyfarm.com.cn/20251230/upload.png" alt="">
                        <div class="upload-btn">点击上传证明材料</div>
                        <div class="upload-tip">支持图片、PDF、Word、Excel格式</div>
                        <div class="upload-tip">单个文件不超过10MB</div>
                    </div>
                </van-uploader>
            </div>

        </div>

        <div class="ft-btn">
            <div class="btns">
                <div class="btn" @click="onSubmit('save')">保存</div>
                <div class="btn submit" @click="onSubmit('sub')">提交</div>
            </div>
        </div>

        <van-popup v-model="showReportTypePicker" round position="bottom">
            <van-picker show-toolbar :default-index="info.reportType - 1" :columns="dictReportType" value-key="dictLabel" @cancel="showReportTypePicker = false" @confirm="onConfirmReportType" />
        </van-popup>

        <van-popup v-model="showStartDatePicker" position="bottom">
            <van-datetime-picker v-model="tempStartDate" type="date" title="选择开始日期" :min-date="minDate" @confirm="onConfirmStartDate" @cancel="showStartDatePicker = false" />
        </van-popup>

        <van-popup v-model="showEndDatePicker" position="bottom">
            <van-datetime-picker v-model="tempEndDate" type="date" title="选择结束日期" :min-date="tempStartDate" @confirm="onConfirmEndDate" @cancel="showEndDatePicker = false" />
        </van-popup>
    </div>
</template>

<script>
    import OSS from 'ali-oss';
    import request from "@/utils/request";
    import { timeToDate2 } from "@/utils/util.js";
    import { getReportDetails, getDictList, reportSave, reportSubmit } from '@/api/crm'
    import { ImagePreview } from 'vant'
    import { timeFormat } from '@/utils/util'
    import { throttle } from 'lodash';

    export default {
        name: 'ReportAdd',
        data() {
            return {
                // OSS客户端实例
                client: null,
                // OSS域名
                domain: null,
                // 控制开始时间选择器显示
                showStartDatePicker: false,
                // 控制结束时间选择器显示
                showEndDatePicker: false,
                // 临时开始时间
                tempStartDate: new Date(Date.now() + 24 * 60 * 60 * 1000),
                // 临时结束时间
                tempEndDate: new Date(Date.now() + 24 * 60 * 60 * 1000),
                // 最小可选日期，默认为明天
                minDate: new Date(Date.now() + 24 * 60 * 60 * 1000),
                // 控制报备类型选择器显示
                showReportTypePicker: false,
                // 报备类型字典
                dictReportType: [],
                // 报备表单信息
                info: {
                    // 门店编号
                    storeNo: '',
                    // 门店名称
                    storeName: '',
                    // 报备类型值
                    reportType: '',
                    // 报备类型名称
                    reportTypeStr: '',
                    // 报备开始时间
                    startDate: '',
                    // 报备结束时间
                    endDate: '',
                    // 报备说明
                    reportDes: '',
                    // 上传文件列表
                    fileUrls: []
                },
                maxSize: 100 * 1024 * 1024,
                maxCount: 9
            }
        },
        created() {
            const { type, id, storeNo, storeName } = this.$route.query
            this.info.storeNo = storeNo
            this.info.storeName = storeName

            if (type === 'edit') {
                this.id = id
                this.getInfo()
            }
            this.getReportType()
        },
        mounted() {
            this.setOSS()
        },
        methods: {
            // 获取报备详情
            async getInfo() {
                try {
                    this.$toast.loading()

                    const res = await getReportDetails(this.id)
                    if (res.code !== 0) throw res.msg

                    this.info = res.data
                    this.$toast.clear()
                } catch (error) {
                    this.$toast(error + '')
                }
            },
            // 获取报备类型字典
            async getReportType() {
                const { data } = await getDictList('qc_report_type')
                this.dictReportType = data
            },
            // 选择报备类型确认事件
            onConfirmReportType(val) {
                this.info.reportType = val.dictValue
                this.info.reportTypeStr = val.dictLabel
                this.showReportTypePicker = false
            },
            // 显示开始时间选择器
            onShowStartDatePicker() {
                this.tempStartDate = this.info.startDate ? new Date(this.info.startDate) : new Date(Date.now() + 24 * 60 * 60 * 1000)
                this.showStartDatePicker = true
            },
            // 显示结束时间选择器
            onShowEndDatePicker() {
                this.tempEndDate = this.info.endDate ? new Date(this.info.endDate) : new Date(Date.now() + 24 * 60 * 60 * 1000)
                this.showEndDatePicker = true
            },
            // 确认选择开始时间
            onConfirmStartDate(date) {
                this.info.startDate = timeFormat(date)
                if (new Date(this.info.startDate).getTime() > new Date(this.info.endDate).getTime()) {
                    this.info.endDate = this.info.startDate
                }
                this.showStartDatePicker = false
            },
            // 确认选择结束时间
            onConfirmEndDate(date) {
                this.info.endDate = timeFormat(date)
                this.showEndDatePicker = false
            },
            // 提交或保存报备事件
            onSubmit: throttle(async function (type = 'sub') {
                try {
                    this.$toast.loading()
                    const req = { ...this.info }

                    if(!req.storeNo || req.storeNo === 'null') throw '请选择报备门店'

                    if (!req.reportType) throw '报备类型必填'
                    if (!req.startDate) throw '生效开始时间必填'
                    if (!req.endDate) throw '生效结束时间必填'
                    if (req.reportDes.length < 20) throw '报备说明至少20个字'

                    const { code, msg } = type === 'sub' ? await reportSubmit(req) : await reportSave(req)

                    if (code !== 0) throw msg
                    this.$toast(`${type === 'sub' ? '提交' : '保存'}成功`)

                    setTimeout(() => {
                        this.$router.replace('/CRM/report')
                    }, 500);
                } catch (error) {
                    this.$toast(error + '')
                }
            }, 2000),
            // 设置OSS配置
            setOSS() {
                request({
                    url: `/aliyun/token`,
                    method: "get",
                })
                    .then((res) => {
                        // 配置oss
                        this.client = new OSS({
                            region: res.data.region,
                            //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，创建并使用STS方式来进行API访问
                            accessKeyId: res.data.accessKeyId,
                            accessKeySecret: res.data.accessKeySecret,
                            stsToken: res.data.securityToken,
                            bucket: res.data.bucket
                        });
                        this.domain = res.data.domain

                    }).catch((error) => {
                        this.$toast(error + '')
                    })
            },
            // i: 重新上传的索引, 默认-1
            afterRead(file, i = -1) {
                this.$toast.loading({
                    message: "上传中...",
                    forbidClick: true,
                });
                let that = this;
                // 配置名字
                let files = file.file;
                const size = files.size
                const point = files.name.lastIndexOf('.')
                const suffix = files.name.substr(point)
                const file_name = files.name.substr(0, point)
                const dateName = files.lastModified;
                const fileNames = `${file_name}${dateName}${suffix}`
                // 分片上传文件
                let datefile = timeToDate2();

                that.client.multipartUpload("/ques/" + datefile + "/" + fileNames, files, {
                    progress: async function (p) {
                        if (p == 1) {
                            that.$toast('文件上传成功')
                            // const file_size = size > 100 * 1000 ? (size / 1000 / 1000).toFixed(2) + 'MB' : (size / 1000).toFixed(2) + 'KB'
                            const file_url = that.domain + "/ques/" + datefile + "/" + fileNames

                            if (i > -1) {
                                that.info.fileUrls.splice(i, 1, file_url)
                            } else {
                                that.info.fileUrls.push(file_url)
                            }
                        }
                    }
                })
            },
            onOversize() {
                Toast(`文件大小不能超过100MB`);
            },
            onDelFile(i) {
                this.info.fileUrls.splice(i, 1)
            },
            // 查看图片
            imagePreview(url) {
                ImagePreview({
                    images: [url],
                    closeable: true,
                    closeIcon: 'close',
                })
            },
            getFileName(url) {
                return url.split('/').pop() || ''
            },
            isImageFile(url) {
                // 获取文件扩展名
                const extension = url.substring(url.lastIndexOf('.') + 1).toLowerCase();
                // 支持的图片扩展名列表
                const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
                // 判断当前文件扩展名是否为图片扩展名
                return imageExtensions.includes(extension);
            }
        }
    }
</script>

<style lang='less' scoped>
    .report-add {
        height: 100%;
        font-size: 28px;
        padding: 30px 30px 210px;
        color: #35434c;
        background-color: #F9FAFC;
        overflow-y: scroll;
    }

    .card {
        padding: 30px;
        padding-bottom: 30px;
        margin-bottom: 20px;
        background-color: #fff;
        border-radius: 20px;
    }

    .card-hd {
        display: flex;
        align-items: center;
        font-size: 34px;
        font-weight: 500;

        >img {
            width: 40px;
            height: 40px;
            margin-right: 4px;
        }
    }

    .report-item {
        display: flex;
        margin-top: 30px;
    }

    .item-label {
        width: 150px;
        line-height: 70px;
        color: #A0ACB5;
    }

    .item-value {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 70px;
        padding: 0 20px;
        background-color: #F3F5F6;
        border-radius: 6px;

        >img {
            width: 30px;
            height: 30px;
        }
    }

    .item-textarea {
        position: relative;
        flex: 1;
        padding-bottom: 20px;
        background-color: #F3F5F6;
    }

    .textarea-tips {
        position: absolute;
        right: 20px;
        bottom: 10px;
        font-size: 22px;
        color: #A0ACB5;
    }

    .red {
        color: #F65252;
    }

    .gery {
        color: #A0ACB5;
    }


    .upload-box {
        height: 308px;
        margin-top: 30px;
        padding-top: 30px;
        text-align: center;
        border: 2px dashed #A0ACB5;
        border-radius: 6px;
    }

    .upload-img {
        width: 80px;
        height: 80px;
    }

    .upload-btn {
        margin-top: 32px;
        margin-bottom: 20px;
    }

    .upload-tip {
        margin-bottom: 10px;
        font-size: 24px;
        color: #A0ACB5;
    }

    .ft-btn {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 180px;
        padding: 40px 100px 50px;
        background-color: #fff;

        .btns {
            display: flex;
            justify-content: space-between;
        }

        .btn {
            width: 250px;
            height: 90px;
            line-height: 90px;
            text-align: center;
            color: #fff;
            background-color: #333F48;
            border-radius: 90px;
        }

        .submit {
            background-color: #2FD0D5;
        }
    }

    .file-list {
        display: flex;
        align-items: center;
        padding: 24px;
        margin-top: 30px;
        font-size: 28px;
        border: 2px solid #e0e0e0;
        border-radius: 12px;
        cursor: pointer;

        .file-img {
            width: 62PX;
            height: 62PX;
        }

        .file-info {
            flex: 1;
            padding-left: 24px;
            overflow: hidden;
        }

        .file-name {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        .file-detail {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 10px;
            color: #999;
        }

        .file-reUpload {
            display: flex;
            align-items: center;
            color: #2eaadd;

            .text {
                margin-right: 30px;
            }
        }
    }
</style>


<style lang="less">
    .report-add {
        .van-field {
            padding: 12px 20px;
            background-color: #F3F5F6;
        }

        .upload-card {

            .van-uploader,
            .van-uploader__input-wrapper {
                width: 100%;
            }
        }
    }

</style>